let CONFIG = {}; // Global , can be used anywhere within application

//CONFIG.LOG_OUT_TOKEN = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjotMSwiaWF0IjoxNjU0MzI5OTc3LCJleHAiOjI1MTgzMjk5Nzd9.w7dBsZs2IztelOh_mfALlprdU37p-Ed57xZogofnhT4`;
CONFIG.LOG_OUT_TOKEN = '';
CONFIG.APP_VERSION = 1071;

module.exports = CONFIG;
